/** @format */

export enum SubmissionErrorCode {
    VALIDATION = '001',
    PRODUCT_ASSIGNED = '002',
    PRODUCT_ALLOCATION = '003',
    PAYMENT_GATEWAY = '009',
    DUPLICATE = '015',
    INVALID_CSRF = '004',
}
